const StepAndConditionCard = ({
  text,
  Icon,
  isSelected,
  onClick,
  type,
  hasAnySelection,
  secondaryText = "",
}) => {
  // Base classes
  const baseClasses =
    "flex flex-col gap-2 px-3.5 py-2.5 max-w-[103px] cursor-pointer rounded-lg border transition-colors";

  const getSelectedClasses = () => {
    if (isSelected) {
      if (type === "condition") {
        return "border-secondary bg-secondary/5";
      }
      if (type === "step") {
        return "border-success-500 bg-success-500/5";
      }
    }
    if (hasAnySelection && !isSelected) {
      return "border-gray-200 dark:border-gray-800 opacity-50 hover:opacity-70 hover:border-gray-300 dark:hover:border-gray-700";
    }
    return "border-gray-200 dark:border-gray-800 hover:border-gray-300 dark:hover:border-gray-700";
  };

  return (
    <div onClick={onClick} className={`${baseClasses} ${getSelectedClasses()}`}>
      {Icon}
      <p className="text-[0.815rem] font-inter text-gray-800 dark:text-gray-200">{text}</p>
      {secondaryText && (
        <span className="text-[0.695rem] text-gray-800 dark:text-gray-300 -mt-1.5">
          {secondaryText}
        </span>
      )}
    </div>
  );
};

export default StepAndConditionCard;
